module.exports = __webpack_public_path__ + "img/stockli-logo-white.bb02a180.png";